$(document).ready(function(){

    $.validator.addMethod("customEmail", function(value, element) {
        return this.optional(element) || /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i.test(value);
    }, "Некорректный email");

    $('.form-validation').each( function(){
        $(this).validate({
            //errorPlacement: $.noop,
            rules:{
                login:{
                    required: true
                },
                password:{
                    required: true,
                    minlength: false
                },
                password_confirmation : {
                    required: true,
                    minlength : false,
                    equalTo : "#password"
                },
                password__two:{
                    required: true,
                    minlength: false
                },
                password_confirmation__two : {
                    required: true,
                    minlength : false,
                    equalTo : "#password__two"
                },
                email: {
                   required: true,
                   //email: true,
                   customEmail:true
                },
                text: {
                    required: true
                },
                tel : {
                    required: true
                }
                },
                messages:{
                login:{
                    required: "Поле обязательно для заполнения"
                },
                password:{
                    required: "Поле обязательно для заполнения",
                    minlength: false
                },
                password_confirmation :{
                    required: "Поле обязательно для заполнения",
                    //minlength: "Пароль должен быть минимум 6 символа"
                    equalTo:  "Пароли не совпадают"
                },
                password__two:{
                    required: "Поле обязательно для заполнения"
                },
                password_confirmation__two : {
                    required: "Поле обязательно для заполнения",
                    //minlength: "Пароль должен быть минимум 6 символа",
                    equalTo:  "Пароли не совпадают"
                },
                email:{
                    required: "Поле обязательно для заполнения",
                    email: "Некорректный email"
                    //required:true
                },
                text:{
                    required: "Поле обязательно для заполнения"
                },
                tel:{
                    required: "Некорректный номер телефона"
                },
                checkbox: {
                    required: "true"
                }
            },
            errorClass: "js-error"
        });
    });
});
